// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AzureAksNodePoolMode = {
  NodePoolModeSystem: 'system',
  NodePoolModeUser: 'user',
} as const;
export type AzureAksNodePoolMode =
  (typeof AzureAksNodePoolMode)[keyof typeof AzureAksNodePoolMode];

export function instanceOfAzureAksNodePoolMode(value: any): boolean {
  for (const key in AzureAksNodePoolMode) {
    if (Object.prototype.hasOwnProperty.call(AzureAksNodePoolMode, key)) {
      if (
        AzureAksNodePoolMode[key as keyof typeof AzureAksNodePoolMode] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AzureAksNodePoolModeFromJSON(json: any): AzureAksNodePoolMode {
  return AzureAksNodePoolModeFromJSONTyped(json, false);
}

export function AzureAksNodePoolModeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AzureAksNodePoolMode {
  return json as AzureAksNodePoolMode;
}

export function AzureAksNodePoolModeToJSON(
  value?: AzureAksNodePoolMode | null,
): any {
  return value as any;
}

export function AzureAksNodePoolModeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AzureAksNodePoolMode {
  return value as AzureAksNodePoolMode;
}
